import { formatMoney } from '../../utils/formatters';

export default function VendorFilterBar({ vendors, active, onFilter }) {
  if (!vendors || vendors.length === 0) return null;

  return (
    <div className="flex gap-3 mb-6 overflow-x-auto pb-1">
      {vendors.map((v) => (
        <button
          key={v.name}
          onClick={() => onFilter(active === v.name ? null : v.name)}
          className={`min-w-[190px] p-4 rounded-xl border text-left transition-all ${
            active === v.name
              ? 'bg-gray-800 text-white border-gray-800'
              : 'bg-white text-gray-800 border-gray-200 hover:border-gray-400'
          }`}
        >
          <div className="text-sm font-bold mb-1">{v.name}</div>
          <div className="text-xl font-extrabold mb-1">{formatMoney(v.total)}</div>
          <div className="text-[11px] opacity-70">
            {v.count} item{v.count !== 1 ? 's' : ''}
            {v.oldest != null && <> &middot; oldest {v.oldest}d</>}
          </div>
        </button>
      ))}
      {active && (
        <button
          onClick={() => onFilter(null)}
          className="min-w-[100px] p-4 rounded-xl border border-dashed border-gray-300 text-gray-400 text-sm font-semibold hover:border-gray-500"
        >
          Show All
        </button>
      )}
    </div>
  );
}
